<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col md="7">
        <h2 class="purple bold">Currículo</h2>
      </b-col>
      <b-col class="text-right">
        <b-button class="large blue outline" href="#" v-if="false"
          >Copiar currículo</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p class="purple">Filtre para obter resultados</p>
      </b-col>
      <b-col md="4">
        <SelectSimple
          v-if="cyclesSel.length"
          v-model="selectedCycle"
          label="Ciclos"
          :options="cyclesSel"
          :callback="(cycle) => selectCycle(cycle, true)"
          :zIndex="1000"
        />

        <span class="clear-field" v-if="selectedCycle" @click="clearFilters"
          >Limpar filtro</span
        >
      </b-col>

      <b-col v-if="subjectsSel.length > 0">
        <SelectSimple
          v-model="selectedSubject"
          label="Áreas do conhecimento"
          :options="subjectsSel"
          :callback="selectSubject"
          :zIndex="1000"
        />
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col>
        <div class="order-grid-box"></div>
      </b-col>
    </b-row>

    <div v-if="competencesWithoutModality.length > 0">
      <b-row
        v-for="competence in competencesWithoutModality"
        :key="competence.id"
        class="line-divider"
        :class="{ disabled: competence.is_active == false }"
      >
        <b-col>
          <b-container fluid>
            <b-row class="header-list-teacher mb-4 font-size-18">
              <b-col md="10">
                <p class="bold text-purple">Competência</p>
              </b-col>
              <b-col>
                <p class="bold">Ativo</p>
              </b-col>
              <b-col>
                <p class="bold">Editar</p>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row align-v="center" class="mb-5">
              <b-col md="10">
                <p class="text-purple bold desc font-size-18">
                  {{ competence.sort_order }} - {{ competence.description }}
                </p>
              </b-col>
              <b-col class="status">
                <b-form-checkbox
                  switch
                  v-if="competence.is_active"
                  v-model="competence.is_active"
                  @input="updateStatus(competence.id, false)"
                ></b-form-checkbox>
                <b-form-checkbox
                  switch
                  v-else
                  v-model="competence.is_active"
                  @input="updateStatus(competence.id, true)"
                ></b-form-checkbox>
              </b-col>
              <b-col>
                <router-link
                  :id="`edit-competence-${competence.id}`"
                  :to="{
                    name: 'editar-competencia',
                    params: {
                      id: competence.id,
                      subject: competence.subject_id,
                    },
                  }"
                >
                  <EditIcon />
                </router-link>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row class="header-list-teacher">
              <b-col md="10">
                <p class="bold font-size-16">Conteúdos</p>
              </b-col>
              <b-col>
                <p class="bold">Ativo</p>
              </b-col>
              <b-col>
                <p class="bold">Editar</p>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row
              align-v="center"
              class="list-teacher"
              v-for="topic in competence.Topics.filter(
                (t) => t.competence_id === competence.id
              ).sort((a, b) => {
                return a.sort_order - b.sort_order;
              })"
              :key="topic.id"
            >
              <b-col md="10">
                <p
                  class="desc font-size-16"
                  v-bind:style="{
                    color: topic.is_editable ? '' : '#a9a9a9',
                  }"
                >
                  {{ competence.sort_order }}.{{ topic.sort_order }} -
                  {{ topic.description }}
                  <span class="red-asterisk" v-if="topic.bncc_code != ''"
                    >*</span
                  >
                </p>
              </b-col>
              <b-col class="status">
                <b-form-checkbox
                  switch
                  v-if="topic.is_editable"
                  v-model="topic.is_editable"
                  @input="updateTopicStatus(topic.id, false)"
                ></b-form-checkbox>
                <b-form-checkbox
                  switch
                  v-else
                  v-model="topic.is_editable"
                  @input="updateTopicStatus(topic.id, true)"
                ></b-form-checkbox>
              </b-col>
              <b-col>
                <router-link
                  :id="`edit-topic-${topic.id}`"
                  :to="{
                    name: 'editar-conteudo',
                    params: {
                      id: topic.id,
                      subject: subject,
                    },
                  }"
                >
                  <EditIcon />
                </router-link>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </div>

    <div v-if="competencesWithTematicUnit.length > 0">
      <b-row
        v-for="competence in competencesWithTematicUnit"
        :key="competence.id"
        class="line-divider"
        :class="{ disabled: competence.is_active == false }"
      >
        <b-col>
          <b-container fluid>
            <b-row class="header-list-teacher mb-4">
              <b-col md="10"
                ><p
                  class="bold text-purple font-size-18"
                  style="text-transform: uppercase"
                >
                  {{ competence.sort_order }} - Unidade Temática:
                  {{ competence.TematicUnit.description }}
                </p></b-col
              >
              <b-col>
                <p class="bold">Ativo</p>
              </b-col>
              <b-col>
                <p class="bold">Editar</p>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row align-v="center" class="mb-5">
              <b-col md="10">
                <p class="text-purple bold desc font-size-18">
                  Competência: {{ competence.description }}
                </p>
              </b-col>
              <b-col class="status">
                <b-form-checkbox
                  switch
                  v-if="competence.is_active"
                  v-model="competence.is_active"
                  @input="updateStatus(competence.id, false)"
                ></b-form-checkbox>
                <b-form-checkbox
                  switch
                  v-else
                  v-model="competence.is_active"
                  @input="updateStatus(competence.id, true)"
                ></b-form-checkbox>
              </b-col>
              <b-col>
                <router-link
                  :id="`edit-competence-tematica-${competence.id}`"
                  :to="{
                    name: 'editar-competencia',
                    params: {
                      id: competence.id,
                      subject: competence.subject_id,
                    },
                  }"
                >
                  <EditIcon />
                </router-link>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row class="header-list-teacher">
              <b-col md="10">
                <p class="bold font-size-16">Conteúdos</p>
              </b-col>
              <b-col>
                <p class="bold">Ativo</p>
              </b-col>
              <b-col>
                <p class="bold">Editar</p>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row
              align-v="center"
              class="list-teacher"
              v-for="topic in competence.Topics.filter(
                (t) => t.competence_id === competence.id
              ).sort((a, b) => {
                return a.sort_order - b.sort_order;
              })"
              :key="topic.id"
            >
              <b-col md="10">
                <p
                  class="desc font-size-16"
                  v-bind:style="{ color: topic.is_editable ? '' : '#a9a9a9' }"
                >
                  <strong>
                    {{ competence.sort_order }}.{{ topic.sort_order }} - Objeto
                    de Conhecimento:
                    {{ topic.KnowledgeObject.description }}</strong
                  >
                  <br />
                  <strong>Conteúdo:</strong>
                  {{ topic.description }}
                  <span class="red-asterisk" v-if="topic.bncc_code != ''"
                    >*</span
                  >
                </p>
              </b-col>
              <b-col class="status">
                <b-form-checkbox
                  switch
                  v-if="topic.is_editable"
                  v-model="topic.is_editable"
                  @input="updateTopicStatus(topic.id, false)"
                ></b-form-checkbox>
                <b-form-checkbox
                  switch
                  v-else
                  v-model="topic.is_editable"
                  @input="updateTopicStatus(topic.id, true)"
                ></b-form-checkbox>
              </b-col>
              <b-col>
                <router-link
                  :id="`edit-topic-tematica-${topic.id}`"
                  :to="{
                    name: 'editar-conteudo',
                    params: {
                      id: topic.id,
                      subject: subject,
                    },
                  }"
                >
                  <EditIcon />
                </router-link>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </div>

    <div v-if="hasLanguageCompetences">
      <div
        v-for="(levelGroup, levelName) in groupedLanguagesByLevel"
        :key="`language-level-${levelName}`"
        class="modality-group"
      >
        <b-card-header
          header-tag="header"
          role="tab"
          style="
            border: 1px solid #dee2e6;
            border-radius: 10px;
            cursor: pointer;
            margin-bottom: 15px;
          "
          v-b-toggle="
            'accordion-language-level-' + getLevelId('language', levelName)
          "
          class="accordion-header"
        >
          <h5 style="color: #666666; margin: 0">{{ levelName }}</h5>
        </b-card-header>

        <b-collapse
          :id="`accordion-language-level-${getLevelId('language', levelName)}`"
          role="tabpanel"
        >
          <b-row
            v-for="competence in levelGroup"
            :key="competence.id"
            class="line-divider"
            :class="{ disabled: competence.is_active == false }"
          >
            <b-col>
              <b-container fluid>
                <b-row class="header-list-teacher mb-4">
                  <b-col md="10"
                    ><p
                      class="bold text-purple font-size-18"
                      style="text-transform: uppercase;"
                    >
                      {{ competence.sort_order }} - Unidade Temática:
                      {{ competence.TematicUnit.description }}
                    </p></b-col
                  >
                  <b-col><p class="bold">Ativo</p></b-col>
                  <b-col><p class="bold">Editar</p></b-col>
                </b-row>
              </b-container>
              <b-container fluid>
                <b-row align-v="center" class="mb-5">
                  <b-col md="10">
                    <p class="text-purple bold desc font-size-18">
                      Competência: {{ competence.description }}
                    </p>
                  </b-col>
                  <b-col class="status">
                    <b-form-checkbox
                      switch
                      v-if="competence.is_active"
                      v-model="competence.is_active"
                      @input="updateStatus(competence.id, false)"
                    ></b-form-checkbox>
                    <b-form-checkbox
                      switch
                      v-else
                      v-model="competence.is_active"
                      @input="updateStatus(competence.id, true)"
                    ></b-form-checkbox>
                  </b-col>
                  <b-col>
                    <router-link
                      :key="`edit-competence-lang-${levelName}-${competence.id}`"
                      :id="`edit-competence-lang-${levelName}-${competence.id}`"
                      :to="{
                        name: 'editar-competencia',
                        params: {
                          id: competence.id,
                          subject: competence.subject_id,
                        },
                      }"
                    >
                      <EditIcon />
                    </router-link>
                  </b-col>
                </b-row>
              </b-container>
              <b-container fluid>
                <b-row class="header-list-teacher">
                  <b-col md="10"
                    ><p class="bold font-size-16">
                      Conteúdos
                    </p></b-col
                  >
                  <b-col><p class="bold">Ativo</p></b-col>
                  <b-col><p class="bold">Editar</p></b-col>
                </b-row>
              </b-container>
              <b-container fluid>
                <b-row
                  align-v="center"
                  class="list-teacher"
                  v-for="topic in competence.Topics.filter(
                    (t) => t.competence_id === competence.id
                  ).sort((a, b) => a.sort_order - b.sort_order)"
                  :key="topic.id"
                >
                  <b-col md="10">
                    <p
                      class="desc font-size-16"
                      v-bind:style="{
                        color: topic.is_editable ? '' : '#a9a9a9',
                      }"
                    >
                      <strong>
                        {{ competence.sort_order }}.{{ topic.sort_order }} -
                        Objeto de Conhecimento:
                        {{ topic.KnowledgeObject.description }}</strong
                      >
                      <br />
                      <strong>Conteúdo:</strong>
                      {{ topic.description }}
                      <span class="red-asterisk" v-if="topic.bncc_code != ''"
                        >*</span
                      >
                    </p>
                  </b-col>
                  <b-col class="status">
                    <b-form-checkbox
                      switch
                      v-if="topic.is_editable"
                      v-model="topic.is_editable"
                      @input="updateTopicStatus(topic.id, false)"
                    ></b-form-checkbox>
                    <b-form-checkbox
                      switch
                      v-else
                      v-model="topic.is_editable"
                      @input="updateTopicStatus(topic.id, true)"
                    ></b-form-checkbox>
                  </b-col>
                  <b-col>
                    <router-link
                      :key="`edit-topic-lang-${levelName}-${topic.id}`"
                      :id="`edit-topic-lang-${levelName}-${topic.id}`"
                      :to="{
                        name: 'editar-conteudo',
                        params: {
                          id: topic.id,
                          subject: subject,
                        },
                      }"
                    >
                      <EditIcon />
                    </router-link>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </div>

    <div v-if="Object.keys(groupedByModalityAndLevel).length > 0">
      <div
        v-for="(modalityLevels, modalityName) in groupedByModalityAndLevel"
        :key="`modality-${modalityName}`"
        class="modality-group"
      >
        <b-card-header
          header-tag="header"
          role="tab"
          style="
            border: 1px solid #dee2e6;
            border-radius: 10px;
            cursor: pointer;
            margin-bottom: 15px;
          "
          v-b-toggle="'accordion-modality-' + getModalityId(modalityName)"
          class="accordion-header"
        >
          <h5 style="color: #495057; margin: 0">{{ modalityName }}</h5>
        </b-card-header>

        <b-collapse
          :id="`accordion-modality-${getModalityId(modalityName)}`"
          role="tabpanel"
        >
          <div
            v-for="(levelGroup, levelName) in modalityLevels"
            :key="`level-${levelName}`"
            style="margin-bottom: 20px"
          >
            <b-card-header
              header-tag="header"
              role="tab"
              style="
                border: 1px solid #dee2e6;
                border-radius: 10px;
                cursor: pointer;
                margin-left: 20px;
              "
              v-b-toggle="
                'accordion-level-' + getLevelId(modalityName, levelName)
              "
              class="accordion-header"
            >
              <h5 style="color: #495057; margin: 0">{{ levelName }}</h5>
            </b-card-header>

            <b-collapse
              :id="`accordion-level-${getLevelId(modalityName, levelName)}`"
              role="tabpanel"
            >
              <b-row
                v-for="competence in levelGroup"
                :key="competence.id"
                class="line-divider"
                style="margin-left: 20px; background-color: #f8f9fa"
                :class="{ disabled: competence.is_active == false }"
              >
                <b-col style="padding-top: 16px">
                  <b-container fluid>
                    <b-row class="header-list-teacher mb-4">
                      <b-col md="10"
                        ><p
                          class="bold text-purple font-size-18"
                          style="text-transform: uppercase"
                        >
                          {{ competence.sort_order }} - Unidade Temática:
                          {{ competence.TematicUnit.description }}
                        </p></b-col
                      >
                      <b-col><p class="bold">Ativo</p></b-col>
                      <b-col><p class="bold">Editar</p></b-col>
                    </b-row>
                  </b-container>
                  <b-container fluid>
                    <b-row align-v="center" class="mb-5">
                      <b-col md="10">
                        <p class="text-purple bold desc font-size-18">
                          Competência:
                          {{ competence.description }}
                        </p>
                      </b-col>
                      <b-col class="status">
                        <b-form-checkbox
                          switch
                          v-if="competence.is_active"
                          v-model="competence.is_active"
                          @input="updateStatus(competence.id, false)"
                        ></b-form-checkbox>
                        <b-form-checkbox
                          switch
                          v-else
                          v-model="competence.is_active"
                          @input="updateStatus(competence.id, true)"
                        ></b-form-checkbox>
                      </b-col>
                      <b-col>
                        <router-link
                          :key="`edit-competence-modality-${modalityName}-${levelName}-${competence.id}`"
                          :id="`edit-competence-modality-${modalityName}-${levelName}-${competence.id}`"
                          :to="{
                            name: 'editar-competencia',
                            params: {
                              id: competence.id,
                              subject: competence.subject_id,
                            },
                          }"
                        >
                          <EditIcon />
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-container>
                  <b-container fluid>
                    <b-row class="header-list-teacher">
                      <b-col md="10"><p class="bold font-size-16">Conteúdos</p></b-col>
                      <b-col><p class="bold">Ativo</p></b-col>
                      <b-col><p class="bold">Editar</p></b-col>
                    </b-row>
                  </b-container>
                  <b-container fluid>
                    <b-row
                      align-v="center"
                      class="list-teacher"
                      v-for="topic in competence.Topics.filter(
                        (t) => t.competence_id === competence.id
                      ).sort((a, b) => a.sort_order - b.sort_order)"
                      :key="topic.id"
                    >
                      <b-col md="10">
                        <p
                          class="desc font-size-16"
                          v-bind:style="{
                            color: topic.is_editable ? '' : '#a9a9a9',
                          }"
                        >
                          <strong>
                            {{ competence.sort_order }}.{{ topic.sort_order }} -
                            Objeto de Conhecimento:
                            {{ topic.KnowledgeObject.description }}</strong
                          >
                          <br />
                          <strong>Conteúdo:</strong>
                          {{ topic.description }}
                          <span
                            class="red-asterisk"
                            v-if="topic.bncc_code != ''"
                            >*</span
                          >
                        </p>
                      </b-col>
                      <b-col class="status">
                        <b-form-checkbox
                          switch
                          v-if="topic.is_editable"
                          v-model="topic.is_editable"
                          @input="updateTopicStatus(topic.id, false)"
                        ></b-form-checkbox>
                        <b-form-checkbox
                          switch
                          v-else
                          v-model="topic.is_editable"
                          @input="updateTopicStatus(topic.id, true)"
                        ></b-form-checkbox>
                      </b-col>
                      <b-col>
                        <router-link
                          :key="`edit-topic-modality-${modalityName}-${levelName}-${topic.id}`"
                          :id="`edit-topic-modality-${modalityName}-${levelName}-${topic.id}`"
                          :to="{
                            name: 'editar-conteudo',
                            params: {
                              id: topic.id,
                              subject: subject,
                            },
                          }"
                        >
                          <EditIcon />
                        </router-link>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </div>

    <b-container v-if="competences.length <= 0 && isRequestSend" fluid>
      <b-row align-v="center" class="list-teacher">
        <b-col>Nenhum resultado encontrado</b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import DataServiceCompetences from "@/services/competences.service";
import DataServiceTopics from "@/services/topics.service";

import SelectSimple from "@/components/inputs/SelectSimple.vue";
import EditIcon from "@/components/svg/EditIcon.vue";
import httpRda from "../../../http-rda";

export default {
  name: "listar-conteudos",
  components: {
    SelectSimple,
    EditIcon,
  },

  data() {
    return {
      descOrder: false,
      isRequestSend: false,
      subject: null,
      searchTitle: "",
      levelLanguageDisabled: {},
      levelDisabled: {},
      cyclesSel: [],
      selectedCycle: null,
      selectedSubject: null,
      subjectsSel: [],
      competences: [],
      loadingCompetences: false,

      breadcrumb: [
        {
          text: "Coordenação",
          href: "/coordenacao/turmas",
        },
        {
          text: "Currículo",
          href: "/coordenacao/conteudos",
          active: true,
        },
      ],
    };
  },

  computed: {
    hasLanguageCompetences() {
      return this.competences.every(
        (competence) => !competence.modality && competence.details
      );
    },

    groupedLanguagesByLevel() {
      const grouped = {};

      this.competences.forEach((competence) => {
        if (competence.details && !competence.modality) {
          const level = competence.details;

          if (!grouped[level]) {
            grouped[level] = [];
            this.levelLanguageDisabled[level] = false;
          }

          grouped[level].push({ ...competence });
        }
      });

      return grouped;
    },

    groupedByModalityAndLevel() {
      const grouped = {};
      let competenceSortOrderByLevel = 1;

      this.competences.forEach((competence) => {
        if (competence.modality) {
          if (!grouped[competence.modality]) {
            grouped[competence.modality] = {};
            this.levelDisabled[competence.modality] = {};
            competenceSortOrderByLevel = 1;
          }

          const level = competence.details || "Sem Nível";

          if (!grouped[competence.modality][level]) {
            grouped[competence.modality][level] = [];
            this.levelDisabled[competence.modality][level] = false;
          }

          grouped[competence.modality][level].push({
            ...competence,
            sort_order: competenceSortOrderByLevel,
          });
          competenceSortOrderByLevel++;
        }
      });

      return grouped;
    },

    competencesWithoutModality() {
      return this.competences.filter(
        (competence) =>
          !competence.modality && !competence.details && !competence.TematicUnit
      );
    },

    competencesWithTematicUnit() {
      return this.competences.filter(
        (competence) =>
          !competence.modality && !competence.details && competence.TematicUnit
      );
    },
  },

  methods: {
    async getCompetencesWithTopics(subjectId) {
      if (!subjectId) {
        this.competences = [];
        return;
      }
      this.loadingCompetences = true;
      this.competences = [];

      try {
        const response = await httpRda.get(
          `competences?include=topics&subject=${subjectId}`
        );
        this.competences = response.data.competences;
        this.isRequestSend = true;
      } catch (error) {
        console.error("Erro ao carregar competências:", error);
      } finally {
        this.loadingCompetences = false;
      }
    },
    async getCycles() {
      const cycles = await httpRda.get("cycles-for-select");
      this.cyclesSel = cycles.data.cycles.map((cycle) => {
        return {
          id: cycle.id,
          label: cycle.name,
        };
      });

      const savedCycle = JSON.parse(localStorage.getItem("selectedCycle"));
      if (savedCycle) {
        this.selectCycle(savedCycle, false);
        this.selectedCycle = savedCycle;
        return;
      }

      this.selectedSubject = null;
    },

    async selectCycle(cycle, changingCycle = true) {
      this.selectedCycle = cycle;
      this.selectedSubject = null;
      this.subjectsSel = [];
      this.competences = [];
      this.isRequestSend = false;

      localStorage.setItem("selectedCycle", JSON.stringify(cycle));

      try {
        const res = await httpRda.get("subjects-select", {
          params: {
            cycleId: this.selectedCycle.id,
          },
        });

        this.subjectsSel = res.data.subjects.map((subject) => ({
          id: subject.subject_id,
          label: subject.subject_designation,
        }));

        const savedSubject = JSON.parse(
          localStorage.getItem("selectedSubject")
        );
        const savedCycle = JSON.parse(localStorage.getItem("selectedCycle"));

        if (
          !changingCycle &&
          savedSubject &&
          savedCycle &&
          savedCycle.id === this.selectedCycle.id
        ) {
          this.selectedSubject = savedSubject;
          await this.selectSubject(savedSubject);
        } else {
          localStorage.removeItem("selectedSubject");
          this.selectedSubject = null;
        }
      } catch (error) {
        console.error("Erro ao carregar subjects:", error);
      }
    },

    async selectSubject(subject) {
      this.competences = [];
      await this.getCompetencesWithTopics(subject.id);
      this.isRequestSend = true;

      this.selectedSubject = subject;
      localStorage.setItem(
        "selectedSubject",
        JSON.stringify(this.selectedSubject)
      );
    },

    getModalityId(modalityName) {
      return modalityName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    },

    getLevelId(modalityName, levelName) {
      return `${this.getModalityId(modalityName)}-${levelName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}`;
    },

    clearFilters() {
      this.selectedCycle = null;
      this.selectedSubject = null;
      this.subjectsSel = [];
      this.isRequestSend = true;
      this.competences = [];
      localStorage.removeItem("selectedCycle");
      localStorage.removeItem("selectedSubject");
    },

    updateStatus(id, status) {
      var data = {
        id: id,
        is_active: status,
      };
      DataServiceCompetences.update(id, data)
        .then((response) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Status atualizado com sucesso!",
          });

          return response.data;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    updateTopicStatus(id, status) {
      var data = {
        id: id,
        is_editable: status,
      };
      DataServiceTopics.update(id, data)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },
  },

  created() {
    this.getCycles(false);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.home {
  height: 100%;
}

.container-rda {
  display: flex;
  flex-direction: column;

  .row.line-divider.disabled {
    order: 1;
  }
}

.desc {
  max-width: 900px;
}

.tags {
  background-color: $blue;
  border-radius: 5px;
  color: $white;
  font-weight: $bold;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  max-width: 58px;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}

.nopadding {
  padding: 0;
}

.row.line-divider {
  & > .col {
    padding-bottom: 20px;
    margin-bottom: 20px;

    &:after {
      background-color: $grey5;
      bottom: 0;
      display: block;
      content: "";
      height: 1px;
      position: absolute;
      width: calc(100% - 30px);
    }
  }
}

::v-deep .card-header {
  background-color: #f7f7f7;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  &.accordion-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.15s;

    &:hover {
      background-color: #e9ecef;
    }

    &:after {
      background: #868e96;
      display: block;
      content: "";
      -webkit-mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      -webkit-mask-size: cover;
      mask-size: cover;
      width: 20px;
      height: 20px;
      transition: all 0.15s;
      transform: rotate(0deg);
      flex-shrink: 0;
    }

    &[aria-expanded="true"]:after {
      transform: rotate(180deg);
    }
  }

  h5 {
    margin: 0;
    color: #495057;
    font-weight: 600;
    pointer-events: none;

    &:hover {
      color: #495057;
    }
  }
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-18 {
  font-size: 18px !important;
}
</style>
